module.exports = __webpack_public_path__ + "img/jetsend-logo.35c7356c.svg";